import { formatNumber } from './formatNumber';
import { parseNumber } from './internal/parseNumber';
import { NON_BREAKING_SPACE } from './internal/unicode';
export var formatDistance = function (distance, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.unit, unit = _a === void 0 ? 'km' : _a;
    var toFormat = parseNumber(distance, 'nb');
    return toFormat === null
        ? ''
        : "".concat(formatNumber(toFormat, { locale: 'nb' })).concat(NON_BREAKING_SPACE).concat(unit);
};
